import remarkBreaks from 'remark-breaks';
import remarkGfm from 'remark-gfm';
import type { PluggableList } from 'unified';

import { remarkCaseIdLinks } from '@/utils/remarkCaseIdLinks';

export const MARKDOWN_REMARK_PLUGINS: PluggableList = [
  remarkBreaks,
  [remarkGfm, { singleTilde: false }],
  remarkCaseIdLinks
];

/**
 * Escapes ~~ in markdown text so it is never rendered as strikethrough.
 * Avoids double-escaping already escaped sequences.
 */
export const escapeStrikethrough = (text: string): string =>
  text.replace(/(?<!\\)~~/g, '\\~\\~');
